import { render, staticRenderFns } from "./CategoriesDescription.vue?vue&type=template&id=7cfc2bde&"
import script from "./CategoriesDescription.vue?vue&type=script&lang=js&"
export * from "./CategoriesDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports